/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

// import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../../../store";

export const isConnectedSelector = (state: AppState) => state.migration.isConnected;
export const loginRequestSelector = (state: AppState) => state.migration.loginRequest;
export const initialMigrationDataSelector = (state: AppState) => state.migration.initialMigrationData;
